"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _vars = require("../../styles/vars");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
//helpers

var getFontSize = function getFontSize(p) {
  var size = _vars.headingFontSizes[p.size] ? p.size : 'normal';
  return _vars.headingFontSizes[size][p.device];
};
var lineHeight = 1.5;
var Heading = exports.Heading = _styledComponents["default"].div.withConfig({
  displayName: "styles__Heading",
  componentId: "sc-9sc9vs-0"
})(["font-size:", "rem;font-weight:normal;line-height:", ";margin:0;color:inherit;", ";", ""], getFontSize, lineHeight, function (p) {
  return p.ellipsis && "\n    display: inline-block;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  ";
}, function (p) {
  return p.maxLines && (0, _styledComponents.css)(["max-height:", "rem;overflow:hidden;"], function (p) {
    return getFontSize(p) * lineHeight * p.maxLines;
  });
});
//# sourceMappingURL=styles.js.map